// Guard to avoid redeclaration when bundled
if (typeof window === 'undefined' || !window.Modal) {
  class Modal {

      constructor(id) {

        this.id = id;
        this.element = $('#' + id);
        this.state = 0;
        this.event = new EventEmitter();

        window.addEventListener('keyup', (e) => {
          if(e.key == 'Escape' && this.state) {
            this.hide();
          }
        });

      }

      show() {
        this.state = 1;
        this.element.removeClass('pointer-events-none');
        this.element.find('div.backdrop').removeClass('opacity-0').addClass('opacity-100');
        this.element.find('div.modal-content').removeClass('opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95').addClass('opacity-100 translate-y-0 sm:scale-100');
        this.event.next('show', true);
      }

      hide() {
        this.state = 0;
        this.element.addClass('pointer-events-none');
        this.element.find('div.backdrop').addClass('opacity-0').removeClass('opacity-100');
        this.element.find('div.modal-content').addClass('opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95').removeClass('opacity-100 translate-y-0 sm:scale-100');
        this.event.next('hide', true);
      }

    }

  if (typeof window !== 'undefined') {
    window.Modal = Modal;
  } else {
    globalThis.Modal = Modal;
  }
}